module.exports = __webpack_public_path__ + "static/img/next-step.c37cdfee.png";